<template>
  <div>
    <div v-if="inWeixin" class="text-center padding-lg">登录中...</div>
    <div v-else class="text-center padding-lg">请在微信中访问</div>
  </div>
</template>

<script>
  import { getWeixinOAuth2Url } from '@/api/weixin'
  import { isWeixin } from '@/libs/util'

  export default {
    name: 'login-weixin',
    data () {
      return {
        inWeixin: isWeixin
      }
    },
    methods: {

    },
    mounted() {
      if (this.inWeixin) {
        // 获取网页授权url
        getWeixinOAuth2Url(this.$route.query.uri).then(res => {
          const data = res.data;
          if (data.code == 0) {
            const oauth2Url = data.url
            console.log('网页授权跳转：'+ oauth2Url)
            window.location.replace(oauth2Url)
          } else {
            alert('获取网页授权url失败：'+ data.msg)
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>

</style>
